import { createContext } from 'react';

import { DeviceQueryResult, DeviceQueryResults } from '@totem/types/devices';

interface Context {
  loading: boolean;
  deviceData: DeviceQueryResults;
  selectedDevices: DeviceQueryResult[];
  selectDevice: (item: DeviceQueryResult) => void;
  deselectDevice: (item: DeviceQueryResult) => void;
  clearSelectedDevices: () => void;
  totalRecords: number;
  onAction?: (action: string, device: DeviceQueryResult) => void;
}

export default createContext<Context>({
  loading: false,
  deviceData: null,
  selectedDevices: [],
  selectDevice: () => {},
  deselectDevice: () => {},
  clearSelectedDevices: () => {},
  totalRecords: 0,
  onAction: null,
});
